<template>
  <v-card
    class="d-flex flex-column"
    style="height: calc(100vh - 80px); overflow: hidden"
  >
    <!-- Barra de búsqueda -->
    <div class="search-container">
      <v-text-field
        v-model="searchDispositivo"
        label="Buscar Dispositivo"
        single-line
        hide-details
        dense
        outlined
        @input="handleSearch"
      ></v-text-field>
      <v-btn
        color="primary"
        dark
        small
        class="mt-2"
        @click="clearFilters"
        :disabled="!searchDispositivo"
      >
        <v-icon left>mdi-filter-remove</v-icon>
        Limpiar Filtros
      </v-btn>

      <v-switch
        v-model="mostrarAceleraciones"
        label="Mostrar aceleraciones"
        hide-details
        dense
        class="mt-2"
      />
    </div>

    <v-progress-linear v-if="loading" indeterminate color="primary" />

    <v-data-table
      v-else
      :headers="headers"
      :items="filteredIncidents"
      class="elevation-1"
      v-model:items-per-page="itemsPerPage"
      :page="page"
      hide-default-footer
      fixed-header
    >
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title>Incidencias recientes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="fetchIncidents"
            small
            style="margin-right: 8px"
          >
            <v-icon left>mdi-refresh</v-icon>
            Recargar
          </v-btn>
        </v-toolbar>
      </template>

      <template #item="{ item }">
        <tr>
          <td><v-icon color="red" class="mr-1">mdi-alert</v-icon> Impacto</td>
          <td>
            <v-chip
              color="primary"
              text-color="white"
              @click="goToEventos(item.ApodoDispositivo)"
              style="cursor: pointer"
              small
              class="ma-1"
            >
              <v-icon left small>mdi-bluetooth-connect</v-icon>
              {{ item.ApodoDispositivo }}
            </v-chip>
          </td>
          <td>
            <v-chip color="blue" text-color="white" small class="ma-1">
              <v-icon left small>mdi-access-point-network</v-icon>
              {{ item.ApodoLector }}
            </v-chip>
          </td>
          <td>
            <v-switch
              v-model="item.tmpGolpeReal"
              :false-value="false"
              :true-value="true"
              color="red"
              hide-details
              dense
              :disabled="item.revisado"
            />
          </td>
          <td>
            <v-switch
              v-model="item.tmpDanio"
              :false-value="false"
              :true-value="true"
              color="red"
              hide-details
              dense
              :disabled="item.revisado"
            />
          </td>
          <td>
            <v-btn
              :color="item.revisado ? 'success' : 'grey'"
              @click="abrirConfirmacion(item)"
              small
              :disabled="item.revisado"
            >
              {{ item.revisado ? "Cerrada" : "Abierta" }}
            </v-btn>
          </td>
          <td>
            <v-icon color="primary" class="mr-1">mdi-clock-outline</v-icon>
            {{ item.Time }}
          </td>
          <td v-if="mostrarAceleraciones">{{ item.accelxmax ?? "-" }}</td>
          <td v-if="mostrarAceleraciones">{{ item.accelymax ?? "-" }}</td>
          <td v-if="mostrarAceleraciones">{{ item.accelzmax ?? "-" }}</td>
          <td v-if="mostrarAceleraciones">{{ item.accelxmin ?? "-" }}</td>
          <td v-if="mostrarAceleraciones">{{ item.accelymin ?? "-" }}</td>
          <td v-if="mostrarAceleraciones">{{ item.accelzmin ?? "-" }}</td>
        </tr>
      </template>

      <template #bottom>
        <div
          class="d-flex w-100 pa-2 align-center justify-space-between flex-wrap"
        >
          <div class="d-flex align-center flex-wrap">
            <v-select
              v-model="itemsPerPage"
              :items="[10, 20, 50, 100]"
              label="Filas por página"
              dense
              outlined
              hide-details
              style="max-width: 150px"
              class="mr-4"
            />
            <v-pagination
              v-model="page"
              :length="Math.ceil(filteredIncidents.length / itemsPerPage)"
              total-visible="2"
              class="mr-4"
            />
            <span>Total: {{ filteredIncidents.length }}</span>
            <div class="date-filter-container">
              <v-date-input
                v-model="startDate"
                label="Desde"
                density="comfortable"
                hide-details
                style="min-width: 170px"
                class="mr-2"
                @update:modelValue="fetchIncidents"
              />
              <v-date-input
                v-model="endDate"
                label="Hasta"
                density="comfortable"
                hide-details
                style="min-width: 170px"
                @update:modelValue="fetchIncidents"
              />
            </div>
          </div>
          <div class="d-flex">
            <v-btn color="success" dark small @click="exportExcel">
              <v-icon left>mdi-file-excel</v-icon> Exportar Excel
            </v-btn>
            <v-btn color="red" dark small class="ml-2" @click="exportPDF">
              <v-icon left>mdi-file-pdf-box</v-icon> Exportar PDF
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      timeout="3000"
      location="bottom"
      elevation="2"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-card>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="text-h6">Confirmar cierre</v-card-title>
      <v-card-text>
        ¿Estás seguro de que quieres cerrar esta incidencia? No se podrá
        modificar después.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="dialog = false">Cancelar</v-btn>
        <v-btn color="primary" text @click="confirmarYCerrar">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import api from "@/services/api";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const router = useRouter();

const incidents = ref([]);
const loading = ref(false);
const searchDispositivo = ref("");
const page = ref(1);
const itemsPerPage = ref(10);
const mostrarAceleraciones = ref(false);

const dialog = ref(false);
const itemToConfirm = ref(null);

const snackbar = ref(false);
const snackbarText = ref("");
const snackbarColor = ref("success");

const now = new Date();
const startDate = ref(
  new Date(now.getFullYear(), now.getMonth(), now.getDate() - 3)
);
const endDate = ref(new Date(now.getFullYear(), now.getMonth(), now.getDate()));

const headers = computed(() => {
  const baseHeaders = [
    { title: "Estado", value: "Estado", sortable: false },
    { title: "Apodo Dispositivo", value: "ApodoDispositivo", sortable: true },
    { title: "Apodo Lector", value: "ApodoLector", sortable: true },
    { title: "Golpe real", value: "GolpeReal", sortable: false },
    { title: "Daño en pieza", value: "DanoPieza", sortable: false },
    { title: "Revisada", value: "Revisada", sortable: false },
    { title: "Timestamp", value: "Time", sortable: true },
  ];

  const accelHeaders = [
    { title: "AccelX Max", value: "AccelXmax", sortable: false },
    { title: "AccelY Max", value: "AccelYmax", sortable: false },
    { title: "AccelZ Max", value: "AccelZmax", sortable: false },
    { title: "AccelX Min", value: "AccelXmin", sortable: false },
    { title: "AccelY Min", value: "AccelYmin", sortable: false },
    { title: "AccelZ Min", value: "AccelZmin", sortable: false },
  ];

  return mostrarAceleraciones.value
    ? [...baseHeaders, ...accelHeaders]
    : [...baseHeaders];
});

const filteredIncidents = computed(() => {
  if (!searchDispositivo.value) return incidents.value;
  return incidents.value.filter((item) =>
    item.ApodoDispositivo?.toLowerCase().includes(
      searchDispositivo.value.toLowerCase()
    )
  );
});

// Maneja la búsqueda en el campo de texto
function cleanIncidentData(rawData) {
  return rawData.map((item) => ({
    ...item,
    revisado: item.revisado ?? false,
    tmpGolpeReal: item.hubo_golpe_real ?? false,
    tmpDanio: item.hubo_danio ?? false,
    accelxmax: item.accelxmax ?? null,
    accelxmin: item.accelxmin ?? null,
    accelymax: item.accelymax ?? null,
    accelymin: item.accelymin ?? null,
    accelzmax: item.accelzmax ?? null,
    accelzmin: item.accelzmin ?? null,
  }));
}

function goToEventos(apodo) {
  router.push({ name: "NewData", query: { search: apodo } });
}

function clearFilters() {
  searchDispositivo.value = "";
  page.value = 1;
}

async function fetchIncidents() {
  loading.value = true;
  try {
    const params = {};
    const formatDate = (date) =>
      new Date(date).toISOString().slice(0, 19).replace("T", " ");

    if (startDate.value) params.start_date = formatDate(startDate.value);
    if (endDate.value) params.end_date = formatDate(endDate.value);

    const data = await api.getIncidencias(params);
    incidents.value = cleanIncidentData(data);
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
}

async function confirmarRevision(item) {
  item.revisado = !item.revisado;
  try {
    await api.setImpacto({
      dispositivo: item.Dispositivo,
      lector: item.Lector,
      time: item.Time,
      revisado: item.revisado,
      hubo_golpe_real: item.tmpGolpeReal,
      hubo_danio: item.tmpDanio,
    });
    showSnackbar(
      item.revisado ? "Incidencia cerrada" : "Incidencia abierta",
      "success"
    );
  } catch (err) {
    console.error("Error al guardar impacto", err);
    item.revisado = !item.revisado; // revertir si falla
    showSnackbar("Error al guardar la revisión", "error");
  }
}

// Muestra un snackbar con un mensaje
function showSnackbar(message, color = "success") {
  snackbarText.value = message;
  snackbarColor.value = color;
  snackbar.value = true;
}

// Abre el diálogo de confirmación
function abrirConfirmacion(item) {
  itemToConfirm.value = item;
  dialog.value = true;
}

// Confirma el cierre de la incidencia y cierra el diálogo
function confirmarYCerrar() {
  if (!itemToConfirm.value) return;
  confirmarRevision(itemToConfirm.value);
  dialog.value = false;
}

async function exportExcel() {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Incidencias");
  worksheet.columns = headers.value.map((h) => ({
    header: h.title,
    key: h.value,
    width: 25,
  }));
  filteredIncidents.value.forEach((item) => {
    worksheet.addRow(item);
  });
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "incidencias.xlsx");
}

async function exportPDF() {
  const doc = new jsPDF("p", "mm", "a4");
  doc.setFontSize(20);
  doc.text("Incidencias", 14, 20);
  doc.setFontSize(10);
  doc.text(`Exportado el: ${new Date().toLocaleString()}`, 14, 27);

  const columns = headers.value.map((h) => ({
    header: h.title,
    dataKey: h.value,
  }));
  const rows = filteredIncidents.value.map((item) => ({
    Estado: "Impacto",
    ApodoDispositivo: item.ApodoDispositivo,
    ApodoLector: item.ApodoLector,
    Time: item.Time,
  }));

  autoTable(doc, {
    startY: 35,
    head: [columns.map((c) => c.header)],
    body: rows.map((row) => columns.map((c) => row[c.dataKey])),
    theme: "striped",
    headStyles: { fillColor: [22, 160, 133] },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    styles: { fontSize: 8, cellPadding: 3 },
    margin: { left: 10, right: 10 },
  });

  doc.save("incidencias.pdf");
}

onMounted(() => {
  fetchIncidents();
});
</script>

<style scoped>
.search-container {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}
.date-filter-container {
  padding-left: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
</style>
